import styled from "styled-components";
import React, { useState } from 'react';
import { remove, uniq } from "lodash";

const MultiCheckBox = ({ name, setPayload, options, errorMessage, errorType }) => {
  const [val, setVal] = useState([]);

  const getOptions = (options, setPayload, name) => {
    if(options) {
      return Object.keys(options).map((key) =>
        <CheckBoxContainer key= { key }>
          <CheckBox
            type="checkbox"
            value={ key }
            key= { key }
            onClick = { e => { handleClick(e, setPayload, name) } }
          />
          <span>{options[key]}</span>
        </CheckBoxContainer>
      );
    } else {
      return null;
    }
  }
  
  const handleClick = (e, setPayload, name) => {
    let payload = val;
    if(e.target.checked) {
      payload.push(e.target.value);
    } else {
      remove(payload, (n) => {
        return e.target.value === n;
      });
    }
    payload = uniq(payload);
    setVal(payload);
    setPayload(name, payload);
  }

  return (
    <Container>
      <CheckBoxContainer>
        <CheckBox type="checkbox" value="ANY" key= "ANY" onClick = { e => { handleClick(e, setPayload, name) } }/>
        <span>Any</span>
      </CheckBoxContainer>
      {getOptions(options, setPayload, name)}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
`;

// Each option is a pill; the native checkbox stays focusable but is visually hidden.
const CheckBoxContainer = styled.label`
  position: relative;
  display: inline-flex;
  align-items: center;

  span {
    display: inline-flex;
    align-items: center;
    min-height: 38px;
    padding: 0 16px;
    border-radius: var(--radius-pill);
    border: 1.5px solid var(--border);
    background: var(--input-bg);
    font-size: 14px;
    font-weight: 600;
    color: var(--text-muted);
    cursor: pointer;
    transition:
      background-color 0.25s var(--ease-out),
      border-color 0.2s ease,
      color 0.2s ease;
  }

  span:hover {
    border-color: var(--border-strong);
  }
`;

const CheckBox = styled.input`
  position: absolute;
  opacity: 0;
  inset: 0;
  margin: 0;
  cursor: pointer;

  &:checked + span {
    background: var(--indigo);
    border-color: var(--indigo);
    color: var(--butter);
  }

  &:focus-visible + span {
    outline: 3px solid var(--coral);
    outline-offset: 2px;
  }
`;

export default MultiCheckBox;
